import { render, staticRenderFns } from "./larkForm.vue?vue&type=template&id=d56b08e4&scoped=true"
import script from "./larkForm.vue?vue&type=script&lang=js"
export * from "./larkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56b08e4",
  null
  
)

export default component.exports